import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import Album from '../components/album';

const SingleAlbum = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 4rem;
	flex: 1;
	
	@media(max-width: 500px) {
		padding: 0 2rem;
	}
	article img {
		max-width: 400px;
	}
`

export default function Template({data}) {
	return (
		<SingleAlbum>
			<Album node={data.markdownRemark}/>
		</SingleAlbum>
	)
}

export const albumQuery = graphql`
	query AlbumsByPath($path: String!) {
	  markdownRemark(frontmatter: {path: {eq: $path}}) {
	    id
	    frontmatter {
	      title
	      date
	      itunesUrl
	      applemusUrl
	      spotifyUrl
	      googleUrl
	      tidalUrl
	      soundcloudUrl
	      public
	      comingSoon
	      path
	      img {
	        childImageSharp {
	          resolutions(width: 800, height: 800) {
	            src
	          }
	        }
	      }
	    }
	  }
	}
`



// WEBPACK FOOTER //
// ./src/templates/album.js